import React, { useEffect, useState } from "react";
import { Checkbox, AutoComplete, InputNumber, Button, Table, Card, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { getAccountBySeachApi } from "../../../apiservice/setting";

const { Summary } = Table;

const AddExpensesSection = ({ onFooterChange, servicePayCart = [] }) => {
  const [indirectToAccs, setIndirectToAccs] = useState([]);
  const [selectedServiceAcc, setSelectedServiceAcc] = useState(null);
  const [serviceTranAmount, setServiceTranAmount] = useState("");
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
     getIndirectAccs();
  }, []);

  const getIndirectAccs = async () => {
    try {
      const res = await getAccountBySeachApi({ multiType: ["direct_income"] });
      const filtered = res.data.filter(
        (item) => !item.display_text.includes("Discount on purchase")
      );
      setIndirectToAccs(filtered);
    } catch (err) {
      setIndirectToAccs([]);
    }
  };

  const addOrUpdateExpense = () => {
    if (!selectedServiceAcc || !serviceTranAmount) return;

    const newEntry = {
      to_acc_id: selectedServiceAcc.acc_id,
      to_acc_name: selectedServiceAcc.acc_name,
      tran_amount: Number(serviceTranAmount),
    };

    let newCart = [...servicePayCart];
    if (editingIndex !== null) {
      newCart[editingIndex] = newEntry;
      setEditingIndex(null);
    } else {
      newCart.push(newEntry);
    }

    onFooterChange(newCart, "payServiceCart");
    setSelectedServiceAcc(null);
    setServiceTranAmount("");
  };

  const edit = (record, index) => {
    setSelectedServiceAcc({ acc_id: record.to_acc_id, acc_name: record.to_acc_name });
    setServiceTranAmount(record.tran_amount);
    setEditingIndex(index);
  };

  const remove = (index) => {
    const newCart = servicePayCart.filter((_, i) => i !== index);
    onFooterChange(newCart, "payServiceCart");
  };

  const columns = [
    { title: "Expense Account", dataIndex: "to_acc_name", key: "to_acc_name" },
    {
      title: "Amount",
      dataIndex: "tran_amount",
      key: "tran_amount",
      align: "right",
      render: (val) => Number(val).toFixed(2),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record, index) => (
        <Space>
          <Button icon={<EditOutlined />} size="small" onClick={() => edit(record, index)} />
          <Button icon={<DeleteOutlined />} danger size="small" onClick={() => remove(index)} />
        </Space>
      ),
    },
  ];

  return (     
        <Card title="Additional Expenses" style={{ marginTop: 4, marginBottom: 5 }}>
          <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
            <AutoComplete
              style={{ flex: 2 }}
              placeholder="Service Account"
              options={indirectToAccs.map((acc) => ({
                value: acc.acc_name,
                label: acc.acc_name,
                obj: acc,
              }))}
              onSelect={(_, option) => setSelectedServiceAcc(option.obj)}
              value={selectedServiceAcc?.acc_name || ""}
              onChange={() => {}}
            />
            <InputNumber
              style={{ flex: 1 }}
              onWheel={(e) => e.target.blur()}
              placeholder="Amount"
              min={0}
              value={serviceTranAmount}
              onChange={setServiceTranAmount}
            />
            <Button type="primary" onClick={addOrUpdateExpense}>
              {editingIndex !== null ? "Update" : "Add"}
            </Button>
          </div>

          <Table
            dataSource={servicePayCart}
            columns={columns}
            pagination={false}
            rowKey={(r, i) => i}
            summary={() => (
              <Summary.Row>
                <Summary.Cell index={0}><strong>Total:</strong></Summary.Cell>
                <Summary.Cell index={1} align="right">
                  <strong>
                    {(servicePayCart || [])
                      .reduce((sum, r) => sum + Number(r.tran_amount || 0), 0)
                      .toFixed(2)}
                  </strong>
                </Summary.Cell>
              </Summary.Row>
            )}
          />
        </Card>     
   
  );
};

export default AddExpensesSection;
